import styled from 'styled-components';
import { LinkButton } from 'components/Toolkit/Button/LinkButton';

const SellerType = styled.div`
  min-width: 0;
  margin-right: ${({ theme }) => theme.spacing.S8};
`;

const SellerTypeLink = styled(LinkButton)`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Rating = styled.div`
  ${({ theme }) => theme.fontSize.M16}
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export { SellerType, SellerTypeLink, Rating };
